<template>
  <div
    class="section section-download"
    id="#download-section"
    data-background-color="black"
  >
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="text-center col-md-12 col-lg-8">
          <h3 class="title">Quer personalizar um treinamento da Cloud CT para sua empresa?</h3>
          <h5 class="description">
            Clique no botão abaixo e preencha o formulário 
            com as tecnologias que sua empresa utiliza para 
            que possamos preparar um plano especial para sua equipe. 
          </h5>
        </div>
        <div class="text-center col-md-12 col-lg-8">
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLScSfT1KrUq1E4_yAf7ckHW5tBwj0UKRzlVfGshyZe-FE7-ypg/viewform"
            class="btn btn-primary btn-lg btn-round"
            target="_blank"
            role="button"
          >
            Formulário de treinamento personalizado
          </a>          
        </div>
      </div>
      <br />
      <br />
      <br />
      <div class="row justify-content-md-center sharing-area text-center mt-5">
        <div class="col-md-8 ml-auto mr-auto">
          <h2>Quer mais?</h2>
          <h5 class="description">
            Tenha acesso gratuito à comunidade Cloud CT. 
            Participe de nosso server no Discord. 
            Utilize nossos projetos open source no GitHub e nos dê uma estrela.                        
          </h5>
        </div>
        <div class="text-center col-md-12 col-lg-8">
          <a
            target="_blank"
            href="https://discord.gg/cYHPWkSp"
            class="btn btn-neutral btn-icon btn-discord btn-lg btn-round"
            rel="tooltip"
            title="Server no Discord"
          >
            <i class="fab fa-discord"></i>
          </a>
          <a
            target="_blank"
            href="https://github.com/cloud-ct"
            class="btn btn-neutral btn-icon btn-github btn-round btn-lg"
            rel="tooltip"
            title="Dê uma estrela no Github"
          >
            <i class="fab fa-github"></i>
          </a>
          <a
            target="_blank"
            href="https://hub.docker.com/u/cloudct"
            class="btn btn-neutral btn-icon btn-docker btn-round btn-lg"
            rel="tooltip"
            title="Acesse nossos repositórios do Docker"
          >
            <i class="fab fa-docker"></i>
          </a>
          
        </div>
      </div>
      <div class="row justify-content-md-center sharing-area text-center">
        <div class="text-center col-md-12 col-lg-8">
          <h3>Obrigado por nos ajudar!</h3>
        </div>        
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'more-section',
};
</script>
<style></style>
